import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import { StatesArray } from '../../global/constants';

import { BlueSwipeCustomerFormSchema } from '../validation';
import { buildDropdown } from '../../dashboard/account/edit-bankaccount-billing-component';
import { getMonthArray, getYearArray } from '../../dashboard/account/edit-creditcard-component';
import { onProfileCompletionSkip } from '../../registration/forms/generic/userInfo2Form';
import { connect } from 'react-redux';

const mapStateToProps = state => ({
  global: state.Global,
  dashboard: state.Dashboard
});

const defaultInitialValues = {
  bill_firstName: '',
  bill_lastName: '',
  bill_address1: '',
  bill_address2: '',
  bill_zip: '',
  bill_city: '',
  bill_state: '',
  card_number: '',
  card_expMonth: '',
  card_expYear: '',
  card_cvv: ''
}

const cssFormControlErrorInput = "form-control error-input";
const cssFormControl = "form-control";

class CreditCardForm extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.getClassNames = this.getClassNames.bind(this);
  }

  onSubmit(values, form) {
    let { handleSubmit } = this.props;
    handleSubmit(values, form);
  }

  getClassNames = (errors, touched) => {

    let billFirstNameCss = cssFormControl;
    if (errors.bill_firstName && touched.bill_firstName)
      billFirstNameCss = cssFormControlErrorInput;

    let billLastNameCss = cssFormControl;
    if ((errors.bill_lastName && touched.bill_lastName))
      billLastNameCss = cssFormControlErrorInput;

    let addressCss = cssFormControl;
    if (errors.bill_address1 && touched.bill_address1)
      addressCss = cssFormControlErrorInput;

    let addressCss2 = cssFormControl;
    if (errors.bill_address2 && touched.bill_address2)
      addressCss2 = cssFormControlErrorInput;

    let zipCss = cssFormControl;
    if (errors.bill_zip && touched.bill_zip)
      zipCss = cssFormControlErrorInput;

    return {
      billFirstNameCss,
      billLastNameCss,
      addressCss,
      addressCss2,
      zipCss
    }
  }

  renderCityState(isMobile, errors, touched) {
    const cssBillCity = (errors.bill_city && touched.bill_city) ? cssFormControlErrorInput : cssFormControl;
    return isMobile
      //Mobile View
      ? (<div><div className="fieldgroup fieldgroup-required">
        <Field
          name="bill_city"
          type="text"
          placeholder="City"
          className={cssBillCity}
        />
        <ErrorMessage name="bill_city" component="div" className="error-message" />
      </div><div className="fieldgroup fieldgroup-required">
          {buildDropdown("bill_state", StatesArray, "State", "State", (errors.bill_state && touched.bill_state))}
          <ErrorMessage name="bill_state" component="div" className="error-message" />
        </div></div>)
      //Desktop View
      : (<div className="fieldgroup row">
        <div className="col-8 pl-0 fieldgroup-required">
          <Field
            name="bill_city"
            type="text"
            placeholder="City"
            className={cssBillCity}
          />
        </div>
        <div className="col-4 pr-0 fieldgroup-required fieldgroup-select">
          {buildDropdown("bill_state", StatesArray, "State", "State", (errors.bill_state && touched.bill_state))}
        </div>
        {((errors.bill_city && touched.bill_city)
          || (errors.bill_state && touched.bill_state))
          && (<div className="error-message">This field is required</div>)}
      </div>)
  }

  renderCardExpiration(isMobile, errors, touched) {
    const cssCVV = (errors.card_cvv && touched.card_cvv) ? cssFormControlErrorInput : cssFormControl;
    return isMobile
      ? (<div><div className="fieldgroup row">
        <div className="d-flex align-items-center mr-3">Expires:</div>
        <div className="col p-0 fieldgroup-required">
          {buildDropdown("card_expMonth", getMonthArray(), "Exp. Month", "MM", (errors.card_expMonth && touched.card_expMonth))}
        </div>
        <div className="d-flex align-items-center pl-1 pr-1">&nbsp;/&nbsp;</div>
        <div className="col p-0 fieldgroup-required">
          {buildDropdown("card_expYear", getYearArray(), "Exp. Year", "YYYY", (errors.card_expYear && touched.card_expYear))}
        </div>
        <ErrorMessage name="card_expMonth" component="div" className="error-message w-100" />
      </div>
        <div className="fieldgroup fieldgroup-required">
          <Field
            name="card_cvv"
            type="text"
            placeholder="CVV"
            className={cssCVV}
          />
          <ErrorMessage name="card_cvv" component="div" className="error-message w-100" />
        </div>
      </div>)
      : (<div className="fieldgroup row">
        <div className="col-8 d-flex pl-0">
          <div className="d-flex align-items-center mr-3">Exp:</div>
          <div className="col p-0 fieldgroup-required fieldgroup-select">
            {buildDropdown("card_expMonth", getMonthArray(), "Exp. Month", "MM", (errors.card_expMonth && touched.card_expMonth))}
          </div>
          <div className="d-flex align-items-center pl-1 pr-1">&nbsp;/&nbsp;</div>
          <div className="col p-0 fieldgroup-required fieldgroup-select">
            {buildDropdown("card_expYear", getYearArray(), "Exp. Year", "YYYY", (errors.card_expYear && touched.card_expYear))}
          </div>
        </div>
        <div className="col-4 pr-0 fieldgroup-required">
          <Field
            name="card_cvv"
            type="text"
            placeholder="CVV"
            className={cssCVV}
          />
        </div>
        <ErrorMessage name="card_expMonth" component="div" className="error-message w-100" />
        <ErrorMessage name="card_cvv" component="div" className="error-message w-100" />
      </div>);
  }

  render() {
    let { handleBack, errorMessage, initialValues, isMobile, dispatch, isMandatory } = this.props;
    return (
      <Formik
        validationSchema={BlueSwipeCustomerFormSchema}
        initialValues={initialValues ? initialValues : defaultInitialValues}
        onSubmit={this.onSubmit}>
        {({ errors, touched, isSubmitting }) => {
          const classNames = this.getClassNames(errors, touched);
          return (
            <Form>
              <div>
                <h2>Billing Address</h2>
                <div><i className="fas fa-asterisk required-asterisk"></i> Indicates required field</div>
                <div>
                  <div className="fieldgroup fieldgroup-required">
                    <Field
                      name="bill_firstName"
                      type="text"
                      placeholder="First Name"
                      className={classNames.billFirstNameCss}
                    />
                    <ErrorMessage name="bill_firstName" component="div" className="error-message" />
                  </div>
                  <div className="fieldgroup fieldgroup-required">
                    <Field
                      name="bill_lastName"
                      type="text"
                      placeholder="Last Name"
                      className={classNames.billLastNameCss}
                    />
                    <ErrorMessage name="bill_lastName" component="div" className="error-message" />
                  </div>
                  <div className="fieldgroup fieldgroup-required">
                    <Field
                      name="bill_address1"
                      type="text"
                      placeholder="Address Line 1"
                      className={classNames.addressCss}
                    />
                    <ErrorMessage name="bill_address1" component="div" className="error-message" />
                  </div>
                  <div className="fieldgroup">
                    <Field
                      name="bill_address2"
                      type="text"
                      placeholder="Address Line 2 (Optional)"
                      className={classNames.addressCss2}
                    />
                  </div>
                  {this.renderCityState(isMobile, errors, touched)}
                  <div className="fieldgroup fieldgroup-required">
                    <Field
                      name="bill_zip"
                      type="text"
                      pattern="[0-9]*"
                      placeholder="Zip Code"
                      className={classNames.zipCss}
                    />
                    <ErrorMessage name="bill_zip" component="div" className="error-message" />
                  </div>
                </div>
                <h2>Credit Card</h2>
                <p>Credit card information is used to verify that you are a real person.
                  It is securely encrypted and stored by our Payment Processor. You are never charged until you make a reservation.</p>
                <div>
                  <div className="fieldgroup row fieldgroup-required">
                    <Field
                      name="card_number"
                      type="number"
                      placeholder="Credit Card Number"
                      className={(errors.card_number && touched.card_number) ? cssFormControlErrorInput : cssFormControl}
                    />
                    <ErrorMessage name="card_number" component="div" className="error-message" />
                  </div>
                  {this.renderCardExpiration(isMobile, errors, touched)}
                </div>
                <div>
                  {errorMessage && (<div className="error-message mb-3">{errorMessage.message}</div>)}
                  <div className="button-row row">
                    <div className="col">
                      <label onClick={handleBack}>Back</label>
                    </div>
                    <div className="col text-right submit-btn">
                      {
                        !isMandatory && <button className="btn btn-primary skip-button" type='button'
                          onClick={() => { onProfileCompletionSkip(dispatch) }}>Skip for Now</button>
                      }
                      <button className="btn btn-primary" disabled={isSubmitting} type="submit">{isSubmitting ? 'Verifying...' : 'Submit'}</button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          )
        }}
      </Formik>
    )
  }
}

export default connect(mapStateToProps)(CreditCardForm);
